
<script setup>

  import { useRouter } from 'vue-router';

  import { ArrowLeftCircleIcon } from '@heroicons/vue/24/outline';

  import { posterThemes, posterTheme } from '../stores/activity-5.js';

  import backgroundPath from '../images/wood-background.jpg';

  const router = useRouter();

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="flex flex-col md:flex-row justify-center gap-12 px-6 py-12">

        <div class="flex items-center justify-center">

          <div class="w-full max-w-xl">

            <h2 class="pb-6 border-b-[3px] border-black">

              <div class="text-xl tracking-narrow font-semibold uppercase">Step 2</div>

              <div class="text-4xl md:text-5xl font-heading uppercase">Choose a Theme</div>

            </h2>

            <p class="mt-8">
              
              What story related to Lewis Mountain would you like to tell?

              Click on one of the three themes to make your selection.

              You can change your theme later if you want.

            </p>

            <div class="mt-12 md:mt-24">

              <RouterLink
              
                class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                  
                  hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"

                to="/activity/5/step/1">
                
                <ArrowLeftCircleIcon class="w-8" />

                <span>Back</span>
              
              </RouterLink>

            </div>

          </div>

        </div>

        <div class="flex items-center justify-center">

          <div class="flex flex-col justify-center gap-4 w-full max-w-xl">

            <button
            
              v-for="{ id, label, path } in posterThemes"
            
              class="flex items-center min-h-[128px] px-6 md:px-12 py-6 text-white bg-neutral-500
              
                hover:underline focus-visible:underline bg-cover bg-center"
    
              :style="{ backgroundImage: `url( ${ path } )` }"
              
              @click="posterTheme = id; router.push( { path: '/activity/5/step/3' } )">

              {{ label }}

            </button>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
